// Wrapper analytics léger (GA4 + conversions Google Ads), sans dépendance.
// Les événements ne partent que si gtag est présent. Le Consent Mode
// (cf. public/index.html) gère le dépôt de cookies selon le consentement
// de l'utilisateur — ces helpers ne contournent rien.

// APP NATIVE (rejet Apple 5.1.2(i)) : GA n'est pas chargé dans l'app et `gtag`
// y est un no-op (cf. index.html) ; ce garde explicite documente l'intention et
// évite tout envoi analytics/Ads depuis l'app même si un appelant est ajouté.
function _analyticsDisabled() {
  return typeof window !== "undefined" && window.__GIVELY_NATIVE__;
}

export function trackEvent(name, params = {}) {
  try {
    if (_analyticsDisabled()) return;
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch (_) { /* no-op */ }
}

// Conversion Google Ads. `sendTo` = "AW-XXXXXXXXX/XXXXXXXXX" fourni par
// Google Ads. On lit par défaut un global défini dans index.html
// (window.GIVELY_ADS_*) pour pouvoir brancher l'ID sans toucher au build.
export function trackAdsConversion(sendTo) {
  try {
    if (_analyticsDisabled()) return;  // jamais de conversion Ads dans l'app native
    if (!sendTo) return;
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", { send_to: sendTo });
    }
  } catch (_) { /* no-op */ }
}

// Funnel observabilité — pousse l'event à la fois dans GA4 ET dans les logs
// backend (via le sink /api/telemetry/frontend-log (alias PSP-neutre)). Permet de
// visualiser le parcours utilisateur dans les logs Railway (page paiement
// vue, formulaire commencé, étape X atteinte, etc.).
export function trackFunnel(event, extra = {}) {
  trackEvent(event, extra);
  try {
    // Lazy require pour éviter une dépendance circulaire au boot React.
    // eslint-disable-next-line global-require
    const { api } = require("../context/AuthContext");
    if (api && typeof api.post === "function") {
      api.post("/telemetry/frontend-log", {
        event,
        extra: {
          host: (typeof window !== "undefined" && window.location && window.location.host) || null,
          ...extra,
        },
      }).catch(() => {});
    }
  } catch (_) { /* noop */ }
}
